export default __webpack_public_path__ + "static/media/medical_17.eece1305.jpg";